import BlueButton from "../../../../../common/BlueButton/BlueButton";
import LoadingDisplay from "../../../../../common/LoadingDisplay/LoadingDisplay";
import "./UploadCardContainer.css";
import { useState } from "react";

const UploadTemplatesCardContainer = ({
    item,
    removeItem,
    isButtonGray,
    contentRight,
    contentLeft,
}) => {
    const [containerClass, setContainerClass] = useState(
        "uploadTemplatesCardContainer",
    );

    let displayComponent = (
        <div className={containerClass}>
            <div className="uploadTemplatesCardContent">
                <div className="uploadTemplatesCardContentHeadContainer">
                    <div className="uploadTemplatesCardContentHead">
                        <div className="UploadTemplatesCardImageBackButton">
                            <BlueButton
                                text="X"
                                isDark={true}
                                onClick={() => {
                                    removeItem(item);
                                }}
                                isGray={isButtonGray}
                            />
                        </div>
                        <div className="UploadTemplatesCardTitle">
                            <p>{item.name ? item.name : item.title}</p>
                        </div>
                    </div>
                    <div className="uploadTemplatesCardLineContainer">
                        <hr className="UploadTemplatesCardLine"></hr>
                    </div>
                </div>

                <div className="UploadTemplatesCardImageAndTitle">
                    <img
                        className="UploadTemplatesCardImageDisplay"
                        src={item.thumbnailUrl}
                        alt={item.title}
                        onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = "/imageNotFound.jpg";
                            item.thumbnailUrl = "/imageNotFound.jpg";
                            item.isGone = true;
                            setContainerClass(
                                "uploadTemplatesCardContainerRemove",
                            );
                        }}
                    />
                </div>

                <div className="uploadTemplatesCardImageLoaderInputValues">
                    {contentLeft ? (
                        <div className="uploadTemplatesCardImageLoaderLicenseText">
                            {contentLeft}
                        </div>
                    ) : (
                        <></>
                    )}
                    {contentRight}
                </div>
            </div>
        </div>
    );

    if (item.isLoading) {
        displayComponent = (
            <>
                <div className="uploadTemplatesCardContent">
                    <div className="uploadTemplatesCardLoadingDisplay">
                        <LoadingDisplay invert={true} />
                    </div>
                </div>
            </>
        );
    }

    return displayComponent;
};

export default UploadTemplatesCardContainer;
